import { Component, Input, OnInit } from '@angular/core';
import { InputChangeEventDetail, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-get-reason',
  templateUrl: './modal-get-reason.component.html',
  styleUrls: ['./modal-get-reason.component.scss'],
})
export class ModalGetReasonComponent implements OnInit {
  @Input() title: string;
  @Input() inputLabel: string;
  @Input() confirmButtonText: string;
  reason: string;
  showError: boolean;

  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  reasonChange(event: Event) {
    const customEvent = event as CustomEvent<InputChangeEventDetail>;
    const value = customEvent.detail.value;
    this.reason = value;
    this.showError = false;

    if (!this.reason || this.reason === '') {
      this.showError = true;
      setTimeout(() => (this.showError = false), 3000);
    }
  }

  confirm() {
    if (!this.reason || this.reason === '') {
      this.showError = true;

      setTimeout(() => (this.showError = false), 3000);
      return;
    }

    this.modalController.dismiss({ reason: this.reason }, 'confirm');
  }
}
